import React, { Component } from 'react';

import '../css/bg.css';
import '../css/main-page.css';

import routeConfig from '../config/route.json';
import comingSoonConfig from '../config/coming-soon.json';

import $ from 'jquery';
import { Scrollbars } from 'react-custom-scrollbars';



class SalesBrochure extends Component {

  constructor(props) {
    super(props);
    let lang = window.location.hash.split('/')[1];


    this.state = {
      ...this.props,
      bg: {
        'pic1': '/bg/' + lang + '/sales-brochure/main.png',
        'pic2': '/bg/' + lang + '/sales-brochure/back-1.png',
        'pic3': '/bg/' + lang + '/sales-brochure/front-1.png',
        'pic4': '/bg/' + lang + '/sales-brochure/front-2.png'
      },
      lang: lang
    }
    $('#loader').fadeIn();
  }
  
  componentWillMount() {
    
  }
  
  componentDidMount() {
    let t = this;

    this.t1 = setTimeout(function(){
      t.setState({
        data: t.props.data
      });
    }, 500);
    this.t2 = setTimeout(function(){
      t.setState({
        data: t.props.data
      });
    }, 1500);
    this.t3 = setTimeout(function(){
      t.setState({
        data: t.props.data
      });
    }, 2500);
    this.t4 = setTimeout(function(){
      t.setState({
        data: t.props.data
      });
    }, 4000);
    this.t5 = setTimeout(function(){
      t.setState({
        data: t.props.data
      });
    }, 7000);

    this.props.updateLang();
    this.changePositioning();
    window.addEventListener('resize', this.changePositioning);
    
    $( "#bg-image-1" ).on('load', function() {
      t.pageLoad();
    });
    

    if (window.location.hostname === 'localhost') {
      let _d = [
        "<div>Hard copies of the Sales Brochure </div><div>are available 24 hours for collection at: </div><div>From 11:00 - 20:00 : </div><div>11/F, ICC, 1 Austin Road West, Kowloon; </div><div>From 20:00 - 11:00 (the next day): </div><div>Concierge Desk, 3/F Lobby, </div><div>1 Austin Road West, Kowloon</div>",
        "<p>售樓説明書的印本可於以下時間及地點 </p><p>24小時取閲： </p><p>每日上午十一時至下午八時： </p><p>九龍柯士甸道西1號環球貿易廣場11樓 </p><p>每日下午八時至翌日上午十一時： </p><p>九龍柯士甸道西1號環球貿易廣場3樓大堂禮賓部</p>",
        "<p>售楼説明书的印本可于以下时间及地点 </p><p>24小时取閲： </p><p>每日上午十一时至下午八时： </p><p>九龙柯士甸道西1号环球贸易广场11楼 </p><p>每日下午八时至翌日上午十一时： </p><p>九龙柯士甸道西1号环球贸易广场3楼大堂礼宾部</p>",
        "10-12-2017 14:50:00"
      ];
      let brochure_address = {
        en: _d[0],
        tc: _d[1],
        sc: _d[2]
      };
      console.log('>>> localhost')
      console.log(brochure_address)
      setTimeout(function(){
        t.setState({
          brochure_address: brochure_address
        });
      }, 100)
    } else {
      $.ajax({
        url: '/shk_cms/public/index.php?get_brochure_address',
        success: function(d) {
          let brochure_address = {
            en: d[0],
            tc: d[1],
            sc: d[2]
          };
          console.log('>>> not localhost')
          console.log(brochure_address)
          t.setState({
            brochure_address: brochure_address
          });
        }
      })
    }
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.changePositioning);

    clearTimeout(this.t1);
    clearTimeout(this.t2);
    clearTimeout(this.t3);
    clearTimeout(this.t4);
    clearTimeout(this.t5);
  }

  pageLoad () {
    let t = this;
    t.props.bgImageOnload();

    setTimeout(function(){
      document.getElementById('bg-image-2').classList.remove('bg-flower');
    }, 2200);
    setTimeout(function(){
      document.getElementById('bg-image-3').classList.remove('bg-flower');
    }, 3000);
    setTimeout(function(){
      document.getElementById('bg-image-4').classList.remove('bg-flower');
    }, 3900);
  }

  changePositioning() {
    let windowWidth = $('.App').width();

    if (windowWidth < 1100) {
      windowWidth = 1100
    }

    let bgImage2Top = windowWidth * 0.327 + 'px';
    let bgImage3Top = windowWidth * 0.054 + 'px';
    let bgImage4Top = windowWidth * 0.329 + 'px';

    document.getElementById('bg-image-2-container').style.top = bgImage2Top;
    document.getElementById('bg-image-3-container').style.top = bgImage3Top;
    document.getElementById('bg-image-4-container').style.top = bgImage4Top;

    if ($('.App').height() < 805) {
      $('.main-page-content-container').css({
        'top': '40%'
      })
    }
    console.log("$('.App').height()" + $('.App').height())
    $('.main-page-content-container').css({
      'height': $('.main-page-content-container').width() * 0.6 + 'px'
    })
    // $('.main-page-content-content').css({
    //   'height': $('.main-page-content-content').width() * 0.6 * 0.8 + 'px'
    // })
    $('.main-page-content-content').css({
      'height': '140px'
    })
  }
  
  render() {
    let t = this;
    return <div className="main-page" style={{}}>
        <div id='bg-image-2-container'
          className='bg-image-container'
          style={{
            'width': '24%'
          }}>
          <img src={this.state.bg.pic2} className='bg-image bg-flower' id='bg-image-2'/>
        </div>

        <img src={this.state.bg.pic1} className='bg-image' id='bg-image-1' style={{}}/>

        <div id='bg-image-3-container'
          className='bg-image-container'
          style={{
            'right': '1px',
            'width': '21%'
          }}>
          <img src={this.state.bg.pic3} className='bg-image bg-flower' id='bg-image-3'/>
        </div>
        <div id='bg-image-4-container'
          className='bg-image-container'
          style={{
            'right': '1px',
            'width': '27%'
          }}>
          <img src={this.state.bg.pic4} className='bg-image bg-flower' id='bg-image-4'/>
        </div>

        <div id=''
          className='main-page-content-container'
          style={{
            'left': '9%',
            'width': '28%',
            'top': '48%',
            'height': '100px'
          }}>
          <div
            className='main-page-content-subtitle'
            style={{
              'fontSize': '16px',
              'textShadow': '2px 2px 3px #000, 1px 1px 1px #000, 3px 3px 3px #000'
            }}>
            {this.state.lang === 'en' ? 
              <img style={{'height': '44px'}} src={routeConfig.salesBrochure[this.state.lang].titleUrl}/> : 
              routeConfig.salesBrochure[this.state.lang].name
            }
          </div>
          <div
            className='main-page-sales-brochure-address'
            style={{
              'fontSize': '12px',
              'textShadow': '2px 2px 3px #000, 1px 1px 1px #000, 3px 3px 3px #000',
              'fontFamily': 'Roboto Condensed, sans-serif',
              'color': 'white',
              'letter-spacing': '2px'
            }} dangerouslySetInnerHTML={{__html: this.state.brochure_address ? this.state.brochure_address[this.state.lang] : ''}}>
            
          </div>
          <br/>
          <Scrollbars
              renderTrackHorizontal={props => <div {...props} className="track-horizontal"/>}
              renderThumbHorizontal={props => <div {...props} className="thumb-horizontal"/>}
              // renderTrackVertical={props => <div {...props} className="track-vertical"/>}
              // renderThumbVertical={props => <div {...props} className="thumb-vertical"/>}   
              autoHide
              autoHideTimeout={1000}
              autoHideDuration={200}
              className='main-page-content-content'
              style={{
                'fontSize': '12px',
                'overflowX': 'hidden',
                'left': '4px'
              }}>
            {this.state.data && this.state.data.sales_brochure && this.state.data.sales_brochure.length > 0 ?
              this.state.data.sales_brochure.map(function(elem, idx) {
              return <a className='item-button' key={idx} href={elem.url} target='_blank' style={{

                }}>
                <div className={(t.state.lang == 'en' ? 'item-is-eng' : 'item-is-chi')} style={{
                  'padding': '6px 0',
                  'textShadow': '2px 2px 3px #000, 1px 1px 1px #000, 3px 3px 3px #000'
                }}>
                  {elem[t.state.lang]}
                </div>
              </a>
              }) : <div style={{
                'color': 'white',
                'padding': '6px 0',
                'textShadow': '2px 2px 3px #000, 1px 1px 1px #000, 3px 3px 3px #000'
              }}>{comingSoonConfig[t.state.lang]}</div>
            }
          </Scrollbars>
        </div>
    </div>
  }
};

export default SalesBrochure;



// WEBPACK FOOTER //
// ./src/page/SalesBrochure.js